import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import Booking from "../types/Booking";

type Output = Booking;

export default function useBookingInfoGet (
    bookingInternalId: any,
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    return useCacheQuery<Output>(
        ["booking-info", bookingInternalId],
        () => {
            return client.get<any>(`bookings/` + bookingInternalId);
        },
        options
    );
}